// extracted by mini-css-extract-plugin
export var banner = "facebook-module--banner--KHpcd";
export var button = "facebook-module--button--i-CxY";
export var buttonHolder = "facebook-module--button-holder--MDb4a";
export var link = "facebook-module--link--2k6On";
export var privateGroupHolder = "facebook-module--private-group-holder---9qml";
export var publicGroupHolder = "facebook-module--public-group-holder--UKBzH";
export var span = "facebook-module--span--uCIA7";
export var text = "facebook-module--text--U0N6Q";
export var wrapper = "facebook-module--wrapper--58BaH";